<div class="atn-summit-org-chart-node-panel">
  <atn-ds-integrated-horizontal-tabs>
    <ng-template
      atnDsTab
      name="General"
    >
      <atn-summit-org-chart-node-panel-general-tab />
    </ng-template>

    <ng-template
      atnDsTab
      name="Skills"
    >
      <atn-summit-org-chart-node-panel-skills-tab />
    </ng-template>
    <ng-template
      atnDsTab
      name="Project Engagements"
    >
      <atn-summit-org-chart-node-panel-project-engagements-tab />
    </ng-template>
    <ng-template
      atnDsTab
      name="Availability"
    >
      <atn-summit-org-chart-node-panel-availability-tab />
    </ng-template>
  </atn-ds-integrated-horizontal-tabs>
</div>
